import { IconNameEnum } from "@b2bportal/core-themes";
import type { SvgrComponent } from "@b2bportal/core-types";
import A11yIconActive from "../../assets/client/a11y-icon-active.svg?react";
import A11yIcon from "../../assets/client/a11y-icon.svg?react";
import AirplaneArrive from "../../assets/client/airplane-arrive.svg?react";
import AirplanDepartChfar from "../../assets/client/airplane-depart-chfar.svg?react";
import AirplaneDepart from "../../assets/client/airplane-depart.svg?react";
import AirplaneDouble from "../../assets/client/airplane-double.svg?react";
import AirplaneFintech from "../../assets/client/airplane-fintech.svg?react";
import AirplaneIconFintech from "../../assets/client/airplane-icon-fintech.svg?react";
import AirplaneOutline from "../../assets/client/airplane-outline.svg?react";
import Airplane from "../../assets/client/airplane.svg?react";
import ArrowAction from "../../assets/client/arrow-action.svg?react";
import ArrowBack from "../../assets/client/arrow-back.svg?react";
import ArrowFork from "../../assets/client/arrow-fork.svg?react";
import BaggageChecked from "../../assets/client/baggage-checked.svg?react";
import Bed from "../../assets/client/bed.svg?react";
import Bell from "../../assets/client/bell.svg?react";
import BlackLock from "../../assets/client/black-lock.svg?react";
import BriefCase from "../../assets/client/briefcase-detail.svg?react";
import CalendarLoading from "../../assets/client/calendar-loading.svg?react";
import Calendar from "../../assets/client/calendar.svg?react";
import Cancel from "../../assets/client/cancel.svg?react";
import Card from "../../assets/client/card.svg?react";
import CheckCircle from "../../assets/client/check-circle.svg?react";
import CheckmarkFilled from "../../assets/client/checkmark-filled.svg?react";
import CheckmarkSimple from "../../assets/client/checkmark-simple.svg?react";
import Checkmark from "../../assets/client/checkmark.svg?react";
import Chevron from "../../assets/client/chevron.svg?react";
import CircleCheck from "../../assets/client/circle-check.svg?react";
import ClockOutline from "../../assets/client/clock-outline.svg?react";
import ClockSolo from "../../assets/client/clock-solo.svg?react";
import Clock from "../../assets/client/clock.svg?react";
import Close from "../../assets/client/close.svg?react";
import Copy from "../../assets/client/copy.svg?react";

// Dark Mode Icons
import A11yIconDarkActive from "../../assets/client/darkMode/a11y-icon-active.svg?react";
import A11yIconWhite from "../../assets/client/darkMode/a11y-icon-white.svg?react";
import AirplaneArriveWhite from "../../assets/client/darkMode/airplane-arrive-white.svg?react";
import AirplanDepartChfarWhite from "../../assets/client/darkMode/airplane-depart-chfar-white.svg?react";
import AirplaneDepartWhite from "../../assets/client/darkMode/airplane-depart-white.svg?react";
import AirplaneIconFintechDark from "../../assets/client/darkMode/airplane-icon-fintech-dark.svg?react";
import AirplaneOutlineWhite from "../../assets/client/darkMode/airplane-outline-white.svg?react";
import AirplaneWhite from "../../assets/client/darkMode/airplane-white.svg?react";
import ArrowActionWhite from "../../assets/client/darkMode/arrow-action-white.svg?react";
import ArrowBackWhite from "../../assets/client/darkMode/arrow-back-white.svg?react";
import ArrowForkWhite from "../../assets/client/darkMode/arrow-fork-white.svg?react";
import BaggageCheckedWhite from "../../assets/client/darkMode/baggage-checked.svg?react";
import BedWhite from "../../assets/client/darkMode/bed-white.svg?react";
import BellWhite from "../../assets/client/darkMode/bell-white.svg?react";
import CalendarWhite from "../../assets/client/darkMode/calendar-white.svg?react";
import CancelWhite from "../../assets/client/darkMode/cancel.svg?react";
import CardWhite from "../../assets/client/darkMode/card-white.svg?react";
import CheckmarkSimpleWhite from "../../assets/client/darkMode/checkmark-simple-white.svg?react";
import CheckmarkWhite from "../../assets/client/darkMode/checkmark-white.svg?react";
import ChevronDownWhite from "../../assets/client/darkMode/chevron-down-white.svg?react";
import CloseWhiter from "../../assets/client/darkMode/close-white-opacity-88.svg?react";
import CloseWhite from "../../assets/client/darkMode/close-white.svg?react";
import CopyDark from "../../assets/client/darkMode/copy.svg?react";
import ExternalLinkWhite from "../../assets/client/darkMode/external-link-white.svg?react";
import FilterWhite from "../../assets/client/darkMode/filter-white.svg?react";
import FlightOutlineWhite from "../../assets/client/darkMode/flight-outline.svg?react";
import GreenShieldCheckDark from "../../assets/client/darkMode/green-shield-check-dark.svg?react";
import HotelIconWhite from "../../assets/client/darkMode/hotel-icon-white.svg?react";
import HotelTripsIconWhite from "../../assets/client/darkMode/hotel-trips-icon-white.svg?react";
import InfoGrey from "../../assets/client/darkMode/info-grey.svg?react";
import LocationMarkerWhite from "../../assets/client/darkMode/location-marker-white.svg?react";
import LockLargeWhite from "../../assets/client/darkMode/lock-large-white.svg?react";
import LockWhite from "../../assets/client/darkMode/lock-white.svg?react";
import MissedConnectionWhite from "../../assets/client/darkMode/missed-connection-white.svg?react";
import NavArrowDark from "../../assets/client/darkMode/nav-arrow-dark.svg?react";
import OneWayWhite from "../../assets/client/darkMode/oneway-white.svg?react";
import PassengerWhite from "../../assets/client/darkMode/passenger-white.svg?react";
import RefreshWhite from "../../assets/client/darkMode/refresh-white.svg?react";
import ReloadWhite from "../../assets/client/darkMode/reload.svg?react";
import RoundTripWhite from "../../assets/client/darkMode/roundtrip-white.svg?react";
import ShieldDisruptionWhite from "../../assets/client/darkMode/shield-disruption-white.svg?react";
import ShieldWhite from "../../assets/client/darkMode/shield-white.svg?react";
import TicketWhite from "../../assets/client/darkMode/ticket-white.svg?react";
import TwoUsersIconWhite from "../../assets/client/darkMode/two-users-white.svg?react";
import UnavailableIconDark from "../../assets/client/darkMode/unavailable-icon.svg?react";
import UserIconWhite from "../../assets/client/darkMode/user-white.svg?react";
import WarningOutlineWhite from "../../assets/client/darkMode/warning-outline-white.svg?react";
import WarningTriangleWhite from "../../assets/client/darkMode/warning-triangle.svg?react";
import WarningWhite from "../../assets/client/darkMode/warning-white.svg?react";
import DollarBill from "../../assets/client/dollar-bill.svg?react";
import DollarSign from "../../assets/client/dollar-sign.svg?react";
import ErrorIcon from "../../assets/client/error.svg?react";
import ExternalLink from "../../assets/client/external-link.svg?react";
import Filter from "../../assets/client/filter.svg?react";
import FlightOutline from "../../assets/client/flight-outline.svg?react";
import GreenCheck from "../../assets/client/green-confirmation-check.svg?react";
import GreenShieldCheck from "../../assets/client/green-shield-check.svg?react";
import HotelIcon from "../../assets/client/hotel-icon.svg?react";
import HotelTripsIcon from "../../assets/client/hotel-trips-icon.svg?react";
import Info from "../../assets/client/info.svg?react";
import LocationMarker from "../../assets/client/location-marker.svg?react";
import Lock from "../../assets/client/lock.svg?react";
import MagnifyCheck from "../../assets/client/magnify-check.svg?react";
import MissedConnectionBlack from "../../assets/client/missed-connection-black.svg?react";
import MissedConnection from "../../assets/client/missed-connection.svg?react";
import NavArrow from "../../assets/client/nav-arrow.svg?react";
import OneWay from "../../assets/client/oneway.svg?react";
import OutlinedCheckCircle from "../../assets/client/outlined-check-circle.svg?react";
import OutlinedWarnCircle from "../../assets/client/outlined-warn-circle.svg?react";
import Passenger from "../../assets/client/passenger.svg?react";
import Redirect from "../../assets/client/redirect.svg?react";
import Refresh from "../../assets/client/refresh.svg?react";
import Reload from "../../assets/client/reload.svg?react";
import RoundTrip from "../../assets/client/roundtrip.svg?react";
import ShieldDisruption from "../../assets/client/shield-disruption.svg?react";
import Shield from "../../assets/client/shield.svg?react";
import Ticket from "../../assets/client/ticket.svg?react";
import TwoUsersIcon from "../../assets/client/two-users.svg?react";
import UnavailableIcon from "../../assets/client/unavailable-icon.svg?react";
import UserIcon from "../../assets/client/user.svg?react";
import Warning from "../../assets/client/warning-black.svg?react";
import WarningOutline from "../../assets/client/warning-outline.svg?react";
import WarningTriangle from "../../assets/client/warning-triangle.svg?react";
import WarningError from "../../assets/client/warning.svg?react";

import type { darkModeIcons, lightModeIcons } from "./sharedIcons";

const commonIconsSvg = {
  [IconNameEnum.checkBulletPoint]: OutlinedCheckCircle,
  [IconNameEnum.importantInformation1]: OutlinedWarnCircle,
  [IconNameEnum.importantInformation2]: OutlinedWarnCircle,
  [IconNameEnum.importantInformation3]: OutlinedWarnCircle,
  [IconNameEnum.importantInformation4]: AirplaneDepart,
  [IconNameEnum.cfarHowItWorksLogo]: AirplaneIconFintech,
} as const;

type DarkModeR = {
  [K in keyof typeof darkModeIcons]: SvgrComponent;
};

export const darkModeIconsSvg: DarkModeR = {
  ...commonIconsSvg,
  a11yIcon: A11yIconWhite,
  a11yIconActive: A11yIconDarkActive,
  airplane: AirplaneWhite,
  airplaneArrive: AirplaneArriveWhite,
  airplaneDepart: AirplaneDepartWhite,
  airplaneDouble: AirplaneDouble,
  airplaneFintech: AirplaneFintech,
  airplaneOutline: AirplaneOutlineWhite,
  airplaneOutlineWhite: AirplaneOutlineWhite,
  back: ArrowBackWhite,
  baggageChecked: BaggageCheckedWhite,
  bell: BellWhite,
  calendar: CalendarWhite,
  card: CardWhite,
  clock: Clock,
  copy: CopyDark,
  error: ErrorIcon,
  cancel: CancelWhite,
  checkmark: CheckmarkWhite,
  checkmarkFilled: CheckmarkFilled,
  checkmarkSimple: CheckmarkSimpleWhite,
  chevron: ChevronDownWhite,
  close: CloseWhite,
  circleCheck: CircleCheck,
  filter: FilterWhite,
  flightOutline: FlightOutlineWhite,
  info: InfoGrey,
  locationMarker: LocationMarkerWhite,
  locationMarkerWhite: LocationMarkerWhite,
  lock: LockLargeWhite,
  blackLock: LockWhite,
  oneway: OneWayWhite,
  reload: ReloadWhite,
  roundtrip: RoundTripWhite,
  passenger: PassengerWhite,
  missedConnection: MissedConnection,
  navArrow: NavArrowDark,
  shield: ShieldWhite,
  warning: WarningWhite,
  warningError: WarningError,
  warningTriangle: WarningTriangleWhite,
  shieldDisruption: ShieldDisruptionWhite,
  missedConnectionFintech: MissedConnectionWhite,
  airplaneDepartChfar: AirplanDepartChfarWhite,
  refresh: RefreshWhite,
  ticket: TicketWhite,
  arrowFork: ArrowForkWhite,
  magnifyCheck: MagnifyCheck,
  calendarLoading: CalendarLoading,
  clockSolo: ClockSolo,
  dollarBill: DollarBill,
  dollarSign: DollarSign,
  briefcase: BriefCase,
  flightDetailsModalOutbound: AirplaneOutlineWhite,
  flightDetailsModalInbound: LocationMarkerWhite,
  flightDetailsModalStopover: ClockOutline,
  tripDetails: AirplaneOutlineWhite,
  redirect: Redirect,
  user: UserIconWhite,
  twoUsers: TwoUsersIconWhite,
  hotelIcon: HotelIconWhite,
  greenShieldCheck: GreenShieldCheckDark,
  bed: BedWhite,
  externalLink: ExternalLinkWhite,
  hotelTrips: HotelTripsIconWhite,
  unavailable: UnavailableIconDark,
  backWhite: ArrowBackWhite,
  deleteChip: CloseWhiter,
  [IconNameEnum.disruptionProtection]: AirplaneIconFintechDark,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineOne]: WarningOutlineWhite,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineTwo]: AirplaneOutline,
  [IconNameEnum.rightArrow]: ArrowActionWhite,
  [IconNameEnum.disruptionConfirmationIcon]: GreenCheck,
  [IconNameEnum.disruptionExerciseFullyCoveredIcon]: CheckCircle,
  [IconNameEnum.cfarHowItWorksLogo]: AirplaneIconFintechDark,
};

type LightModeR = {
  [K in keyof typeof lightModeIcons]: SvgrComponent;
};

export const lightModeIconsSvg: LightModeR = {
  ...commonIconsSvg,
  a11yIcon: A11yIcon,
  a11yIconActive: A11yIconActive,
  airplane: Airplane,
  airplaneArrive: AirplaneArrive,
  airplaneDepart: AirplaneDepart,
  airplaneDouble: AirplaneDouble,
  airplaneFintech: AirplaneFintech,
  airplaneOutline: AirplaneOutline,
  airplaneOutlineWhite: AirplaneOutlineWhite,
  back: ArrowBack,
  baggageChecked: BaggageChecked,
  bell: Bell,
  calendar: Calendar,
  cancel: Cancel,
  deleteChip: Cancel,
  card: Card,
  clock: Clock,
  copy: Copy,
  close: Close,
  error: ErrorIcon,
  checkmark: Checkmark,
  checkmarkFilled: CheckmarkFilled,
  checkmarkSimple: CheckmarkSimple,
  chevron: Chevron,
  circleCheck: CircleCheck,
  filter: Filter,
  flightOutline: FlightOutline,
  info: Info,
  locationMarker: LocationMarker,
  locationMarkerWhite: LocationMarkerWhite,
  lock: Lock,
  blackLock: BlackLock,
  oneway: OneWay,
  reload: Reload,
  roundtrip: RoundTrip,
  passenger: Passenger,
  missedConnection: MissedConnection,
  navArrow: NavArrow,
  shield: Shield,
  warning: Warning,
  warningError: WarningError,
  warningTriangle: WarningTriangle,
  shieldDisruption: ShieldDisruption,
  missedConnectionFintech: MissedConnectionBlack,
  airplaneDepartChfar: AirplanDepartChfar,
  refresh: Refresh,
  ticket: Ticket,
  arrowFork: ArrowFork,
  magnifyCheck: MagnifyCheck,
  calendarLoading: CalendarLoading,
  clockSolo: ClockSolo,
  dollarBill: DollarBill,
  dollarSign: DollarSign,
  briefcase: BriefCase,
  flightDetailsModalOutbound: AirplaneOutlineWhite,
  flightDetailsModalInbound: LocationMarkerWhite,
  flightDetailsModalStopover: ClockOutline,
  tripDetails: AirplaneOutline,
  redirect: Redirect,
  user: UserIcon,
  twoUsers: TwoUsersIcon,
  hotelIcon: HotelIcon,
  greenShieldCheck: GreenShieldCheck,
  bed: Bed,
  externalLink: ExternalLink,
  hotelTrips: HotelTripsIcon,
  unavailable: UnavailableIcon,
  backWhite: ArrowBackWhite,
  [IconNameEnum.disruptionProtection]: AirplaneIconFintech,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineOne]: WarningOutline,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineTwo]: AirplaneOutline,
  [IconNameEnum.disruptionExerciseFullyCoveredIcon]: CheckCircle,
  [IconNameEnum.rightArrow]: ArrowAction,
  [IconNameEnum.disruptionConfirmationIcon]: GreenCheck,
};
